import React from 'react';
import { connect } from 'react-redux';
import '../../../css/transaction/TransactionFeesDiscount.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";
import Sidenav from '../../shared/Sidenav';
import Calendar from 'react-calendar';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import 'react-calendar/dist/Calendar.css';
import DeleteModal from '../../shared/DeleteRoleModal';
import SuccessModal from '../../shared/SuccessModal';
import AlertModal from '../../shared/AlertModal';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL, baseURL } from '../../../Services/config/apiGateway';
import { TRANSACTIONDISCOUNT_ENDPOINT, ALLUSERLIST_ENDPOINT } from '../../../Services/config/apiEndPoints';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();
let viewOnly = false;
class TransactionFeesDiscount extends React.Component {
   constructor(props) {
      super(props)
      this.container = React.createRef();
      this.state = {
         monthlyActiveDiv: true,
         monthlyExpiredDiv: false,
         newRowMonth: false,
         showMonthlyEffectiveCalendar: false,
         showMonthlyExpiryCalendar: false,
         monthEffectiveValue: new Date(),
         monthExpiryValue: new Date(),
         monthlyTolAmt: '',
         emailAddress: '',
         fullName: '',
         showEmailSearch: false,
         editIndex: '',
         isEdit: [],
         hasOpenDelete: false,
         hasOpenAlert: false,
         deleteIndex: "",
         showEditFromCalendar: [],
         showEditToCalendar: [],
         transactionDiscountData: [],
         activedata: [],
         confirmedHasOpen: false,
         monthlyEffectiveDateCalendarRender: false,
         monthlyExpiryDateCalendarRender: false,
         validSearch: false,
         userSearch: [],
      }
      this.handleClickOutside = this.handleClickOutside.bind(this);
   }
   componentDidMount = () => {
      document.addEventListener("mousedown", this.handleClickOutside);
      var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x=>
            x.map(md=>{
                if(md.functionId === 17){
                    if(md.method.includes("View & Edit")){
                        viewOnly = true
                    }
                }
                return true;
            }))
      ApiCall(
         'GET',
         serviceBaseURL + TRANSACTIONDISCOUNT_ENDPOINT,
         {},
         {
            Accept: 'application/json',
            'Content-Type': 'application/json',
         },
      ).then((data) => {
         if (data.flag !== -1) {
            if (data.flag === 500) {
               toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
            else {
               console.log('I am 200!');
               console.log(data)
               this.setState({ transactionDiscountData: data })
            }
         } else {
            //   toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
         }
      });
   }
   handleClickOutside = event => {
      if (this.container.current && !this.container.current.contains(event.target)) {
         this.setState({ showMonthlyEffectiveCalendar: false, showMonthlyExpiryCalendar: false, showEmailSearch: false });
         let a = this.state.showEditFromCalendar;
         a[this.state.editIndex] = false
         this.setState({ showEditFromCalendar: a })
         let b = this.state.showEditToCalendar;
         b[this.state.editIndex] = false
         this.setState({ showEditToCalendar: b });
      }
   };
   onCloseAlert = () => {
      this.setState({ hasOpenAlert: false });
   }
   onCloseConfirmed = () => {
      this.setState({ confirmedHasOpen: false });
      window.location.reload();
   }
   onCloseDeleteModal = () => {
      this.setState({ hasOpenDelete: false });
   }
   deleteMonthlySubscription = (deleteIndex) => {
      this.setState({ deleteIndex: deleteIndex, hasOpenDelete: true });
   }
   confirmDelete = () => {
      ApiCall(
         'DELETE',
         serviceBaseURL + TRANSACTIONDISCOUNT_ENDPOINT + `?TransactionDiscountId=${this.state.transactionDiscountData[this.state.deleteIndex].transactionDiscountId}`,
         {},
         {
             Accept: 'application/json',
             'Content-Type': 'application/json',
             'x-cc-trace-id': '1234',
         },
     ).then((apiData) => {
         if (apiData.flag !== -1) {
             if (apiData.flag === 500) {
                 // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
             }
             else {
                 console.log('I am 200!');
                 console.log(apiData.message);
                 this.setState({ confirmedHasOpen: true });
                 this.setState({ hasOpenDelete: false });
             }
         } else {
             // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
         }
     });
   }
   handleEmailAddress = (e) => {
      this.setState({ emailAddress: e.target.value })
      var test1 = e.target.value.length
      if (test1 === 3) {
         //   GET ALL USER LIST API
         ApiCall(
            'GET',
            baseURL + ALLUSERLIST_ENDPOINT + `${e.target.value}`,
            {},
            {
               Accept: 'application/json',
               'Content-Type': 'application/json',
               'x-cc-trace-id': '1234',
            },
         ).then((apiData) => {
            if (apiData.flag !== -1) {
               if (apiData.flag === 500) {
                  toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
               }
               else {
                  console.log('I am 200!');
                  this.setState({ userSearch: apiData, showEmailSearch: true })
               }
            } else {
               // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
         });
      }
   }
   addDiscount = () => {
      if (this.state.isEdit.length > 0) {
         if (this.handleEditValidation()) {
            ApiCall(
               'PUT',
               serviceBaseURL + TRANSACTIONDISCOUNT_ENDPOINT,
               this.state.transactionDiscountData[this.state.editIndex],
               {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'x-cc-trace-id': '1234',
               }
            ).then(data => {
               if (data.flag !== -1) {
                  if (data.flag === 500) {
                     toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                  }
                  else {
                     console.log('I am 200!');
                     this.setState({ confirmedHasOpen: true });
                  }
               }
               else {
                  // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
               }
            })
         }
      }
      else {
         let fromTimeStamp = new Date(this.state.monthEffectiveValue)
         fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(fromTimeStamp).toString().substring(0, 10));
         let toTimeStamp = new Date(this.state.monthExpiryValue)
         toTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(toTimeStamp).toString().substring(0, 10));
         if (this.handleAddValidation()) {
            ApiCall(
               'POST',
               serviceBaseURL + TRANSACTIONDISCOUNT_ENDPOINT,
               {
                  "discountRate": this.state.monthlyTolAmt,
                  "effectiveDate": fromTimeStamp,
                  "expiryDate": toTimeStamp,
                  "fullName": this.state.fullName,
                  "status": "Active",
                  "userEmail": this.state.emailAddress
               },
               {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'x-cc-trace-id': '1234',
               }
            ).then(data => {
               if (data.flag !== -1) {
                  if (data.flag === 500) {
                     if (data.data.message === "Time period Overlapping") {
                        this.setState({ hasOpenAlert: true })
                     }
                     else {
                        toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                     }
                  }
                  else {
                     console.log('I am 200!');
                     this.setState({ confirmedHasOpen: true });
                  }
               }
               else {
                  //toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
               }
            })
         }
      }
   }
   handleAddValidation() {
      let errors = {};
      let formIsValid = true;
      if (new Date(this.state.monthEffectiveValue).getFullYear() > new Date(this.state.monthExpiryValue).getFullYear()) {
         formIsValid = false;
         toast(message.validation.date+"!", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
      }
      if (new Date(this.state.monthEffectiveValue).getFullYear() === new Date(this.state.monthExpiryValue).getFullYear()) {
         if (new Date(this.state.monthEffectiveValue).getMonth() > new Date(this.state.monthExpiryValue).getMonth()) {
            formIsValid = false;
            toast(message.validation.date+"!", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
         }
      }
      if (new Date(this.state.monthEffectiveValue).getFullYear() === new Date(this.state.monthExpiryValue).getFullYear()) {
         if (new Date(this.state.monthEffectiveValue).getMonth() === new Date(this.state.monthExpiryValue).getMonth()) {
            if (new Date(this.state.monthEffectiveValue).getDate() > new Date(this.state.monthExpiryValue).getDate()) {
               formIsValid = false;
               toast(message.validation.date+"!", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
            }
         }
      }
      if (new Date(this.state.monthEffectiveValue).getTime() === new Date(this.state.monthExpiryValue).getTime()) {
         formIsValid = false;
         toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
      }
      this.setState({ errors: errors });
      return formIsValid;
   }
   handleEditValidation() {
      let errors = {};
      let formIsValid = true;
      let fromDateParts = this.state.transactionDiscountData[this.state.editIndex].effectiveDate.split("/");
      let fromDateFormate = new Date(fromDateParts[2], fromDateParts[1] - 1, fromDateParts[0]).toString();
      let toDateParts = this.state.transactionDiscountData[this.state.editIndex].expiryDate.split("/");
      let toDateFormate = new Date(toDateParts[2], toDateParts[1] - 1, toDateParts[0]).toString();
      let toDate = new Date(toDateFormate).getDate()
      let fromDate = (new Date(fromDateFormate)).getDate()
      let toMonth = (new Date(toDateFormate)).getMonth()
      let fromMonth = (new Date(fromDateFormate)).getMonth()
      let toYear = (new Date(toDateFormate)).getFullYear()
      let fromYear = (new Date(fromDateFormate)).getFullYear()
      let toTime = new Date(toDateFormate).getTime()
      let fromTime = (new Date(fromDateFormate)).getTime()
      console.log(fromDateFormate, fromDate)
      if (fromYear > toYear) {
         formIsValid = false;
         toast(message.validation.date+"!", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
      }
      else if (fromYear === toYear) {
         if (fromMonth > toMonth) {
            formIsValid = false;
            toast(message.validation.date+"!", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
         }
         else if (fromMonth === toMonth) {
            if (fromDate > toDate) {
               formIsValid = false;
               toast(message.validation.date+"!", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
            }
         }
      }
      if (fromTime === toTime) {
         formIsValid = false;
         toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
      }
      this.setState({ errors: errors });
      return formIsValid;
   }
   getDate = (timeStamp) => {
      let date = new Date(timeStamp).toString();
      let day = date.split(' ')[2];
      let month = date.split(' ')[1];
      let year = date.split(' ')[3];
      return `${day}-${month}-${year}`;
   }
   showMonthlyActiveScreen = () => {
      this.setState({ monthlyActiveDiv: true, monthlyExpiredDiv: false });
      document.getElementById('monthlyActiveTab').style.borderBottom = "2px solid #857A71";
      document.getElementById('monthlyExpiredTab').style.borderBottom = "none";
   }
   showMonthlyExpiredScreen = () => {
      this.setState({ monthlyActiveDiv: false, monthlyExpiredDiv: true });
      document.getElementById('monthlyExpiredTab').style.borderBottom = "2px solid #857A71";
      document.getElementById('monthlyActiveTab').style.borderBottom = "none";
   }
   addNewRoleMonth = () => {
      this.setState({ newRowMonth: true });
   }
   toggleMonthlyEffectiveCalendar = () => {
      this.setState({ showMonthlyEffectiveCalendar: !this.state.showMonthlyEffectiveCalendar, monthlyEffectiveDateCalendarRender: true });
   }
   handleMonthlyEffectiveDateChanged = (e) => {
      this.setState({ monthEffectiveValue: e, showMonthlyEffectiveCalendar: false });
   }
   handleEditMonthlyEffectiveDateChanged = (e) => {
      this.setState({ monthEffectiveValue: e, showMonthlyEffectiveCalendar: false });
   }
   toggleMonthlyExpiryCalendar = () => {
      this.setState({ showMonthlyExpiryCalendar: !this.state.showMonthlyExpiryCalendar, monthlyExpiryDateCalendarRender: true });
   }
   handleMonthlyExpiryDateChanged = (e) => {
      this.setState({ monthExpiryValue: e, showMonthlyExpiryCalendar: false });
   }
   selectEmail = (e) => {
      const found = this.state.userSearch.find((name) => {
         if (name.userEmail === e.target.innerText) {
            return name
         }
         return true;
      })
      this.setState({ emailAddress: found.userEmail, showEmailSearch: false, validSearch: true });
   }

   fullNameSearch = (e) => {
      const found = this.state.userSearch.find((name) => {
         if (name.userEmail === this.state.emailAddress) {
            return name
         }
         return true;
      })
      this.setState({ fullName: found.firstName + " " + found.lastName });
   }
   toggleSearch = () => {
      this.setState({ showEmailSearch: true });
   };
   validateFormFields = () => {
      let validEdit = [];
      let indexOfedits = [];
      this.state.isEdit.find((edit, index) => {
         console.log("edit", edit)
         if (edit === true) {
            indexOfedits = indexOfedits.concat(index);
         }
         return false;
      });
      for (let i = 0; i < indexOfedits.length; i++) {
         validEdit = validEdit.concat(this.state.transactionDiscountData[indexOfedits[i]].discountRate > 0);
         console.log("insideValidedit", validEdit, "bb", this.state.transactionDiscountData[indexOfedits[i]].discountRate, "vv", i, indexOfedits, indexOfedits[i]);
      }
      return (this.state.emailAddress.length > 0 && this.state.fullName.length > 0 && this.state.monthlyEffectiveDateCalendarRender && this.state.monthlyExpiryDateCalendarRender && this.state.monthlyTolAmt.length > 0) ||
         (this.state.isEdit.includes(true) && !validEdit.includes(false));
   };
   getDate = (dateString) => {
      //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
      let dateParts = dateString.split("/");
      // month is 0-based, that's why we need dataParts[1] - 1
      let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
      let day = date.split(' ')[2];
      let month = date.split(' ')[1];
      let year = date.split(' ')[3];
      return `${day}-${month}-${year}`;
   }
   render() {
      let filteredActiveData = [];
      if (this.state.emailAddress.length > 0) {
         filteredActiveData = this.state.userSearch.filter((i) => {
            return ((i.userEmail).toLowerCase().startsWith(this.state.emailAddress));
         });
      } else {
         filteredActiveData = [];
      }
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let monthlyEffectiveDateValue = this.state.monthEffectiveValue.getDate() + "-" + months[this.state.monthEffectiveValue.getMonth()] + "-" + this.state.monthEffectiveValue.getFullYear();
      if (this.state.monthEffectiveValue.getDate() <= 9) {
         monthlyEffectiveDateValue = "0" + monthlyEffectiveDateValue;
      }
      let monthlyExpiryDateValue = this.state.monthExpiryValue.getDate() + "-" + months[this.state.monthExpiryValue.getMonth()] + "-" + this.state.monthExpiryValue.getFullYear();
      if (this.state.monthExpiryValue.getDate() <= 9) {
         monthlyExpiryDateValue = "0" + monthlyExpiryDateValue;
      }
      return (
         <div className="outer1" id="outerdiv">
            <MetaDecorator title={TitleDescription.transactionFeesDiscountPageTitle} description={TitleDescription.transactionFeesDiscountPageDescription} />
            <div className="screen">
               <div class="TransactionFeesDiscountContainer">
                  <div id="outerheader" >
                  </div>
                  <Sidenav />
                  <div class="TransactionFeesDiscountSection" id="createFeeSection">
                     <p class="pt-2 pb-2" id="TransactionFeesDiscountHeadingTitle">Transaction Fees Discount</p>
                     {/* View Only Access */}
                     <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                        <img alt="View Only Access" src={viewAccess} />
                        <span className="viewOnly">View Only Access</span>
                     </div>
                     <div>
                        <div class="TransactionFeesDiscountCardContainer">
                           <div class="TransactionFeesDiscountMonthlyPlanCardContainer">
                              <div class="TransactionFeesDiscountHeaderDiv">
                                 <div class="TransactionFeesDiscountHeaderDivInner">
                                    <div class="TransactionFeesDiscountActiveExpiredContainer">
                                       <div class="TransactionFeesDiscountActiveDiv" id="monthlyActiveTab" onClick={this.showMonthlyActiveScreen}><small class="activeExpiredTextTransactionFees">Active</small></div>
                                       <div class="TransactionFeesDiscountExpiredDiv" id="monthlyExpiredTab" onClick={this.showMonthlyExpiredScreen}><small class="activeExpiredTextTransactionFees">Expired</small></div>
                                    </div>
                                 </div>
                              </div>
                              {this.state.monthlyActiveDiv && <div>
                                 <div class="TransactionFeesDiscountDataContainer" id="TransactionFeesDiscountTableDataContainer">
                                    <div class="TransactionFeesDiscountDataHeader">
                                       <div class="activeEmailAddressDiv" style={{ width: !viewOnly ? "27%" : "45%" }}><div class="TransactionFeesDiscountEffectiveDate">
                                          <small class="dataHeaderTextTransactionFees">Email Address</small>
                                          <small class="dataHeaderTextTransactionFees">(Premium User)</small>
                                       </div></div>
                                       <div class="activeFullNameDiv" style={{ width: !viewOnly ? "21.5%" : "30%" }}><div class="TransactionFeesDiscountExpiredDate">
                                          <small class="dataHeaderTextTransactionFees">Full Name</small>
                                       </div></div>
                                       <div class="activeDiscountEffectiveDiv" style={{ width: !viewOnly ? "19.3%" : "27%" }}><div class="TransactionFeesDiscountActiveAmt">
                                          <small class="dataHeaderTextTransactionFees">Discount</small>
                                          <small class="dataHeaderTextTransactionFees">Effective Date</small>
                                       </div></div>
                                       <div class="activeDiscountExpiryDiv" style={{ width: !viewOnly ? "21%" : "30%" }}><div class="TransactionFeesDiscountExpiryDate">
                                          <small class="dataHeaderTextTransactionFees">Discount</small>
                                          <small class="dataHeaderTextTransactionFees">Expiry Date</small>
                                       </div></div>
                                       <div class="activeDiscountRateDiv" style={{ width: !viewOnly ? "10%" : "30%" }}><div class="TransactionFeesDiscountRate">
                                          <small class="dataHeaderTextTransactionFees">Discount</small>
                                          <small class="dataHeaderTextTransactionFees">Rate(%)</small>
                                       </div></div>
                                    </div>
                                    {this.state.newRowMonth && <div class="newRowContainer">
                                       <div class="activeTabTransactionEmailDataDiv">
                                          <input class="TransactionFeesDiscountAmtInputBox" placeholder="Search by Email Address" value={this.state.emailAddress}
                                             onChange={this.handleEmailAddress}
                                             onKeyPress={this.toggleSearch}></input>
                                          <img id="searchinput_imgTransactionFeesDiscount" src={require('../../../assets/images/search.svg')} width="16" height="16" alt="" onClick={this.state.emailAddress.length > 0 && this.state.validSearch ? this.fullNameSearch : null} />
                                       </div>
                                       <div class="activeTabTransactionFullNameDataDiv">
                                          <input class="TransactionFeesDiscountfullNameInputBox" readOnly value={this.state.fullName} onChange={e => this.setState({ fullName: e.target.value })}></input>
                                       </div>
                                       <div class="activeTabTransactionEffectiveDateDataDiv">
                                          <input class="TransactionFeesDiscountCalendarInputBox" placeholder="Select Date" readOnly
                                             value={this.state.monthlyEffectiveDateCalendarRender ? monthlyEffectiveDateValue : null}></input>
                                          <div class="TransactionFeesDiscountCalendar">  {this.state.showMonthlyEffectiveCalendar ? <div ref={this.container}> <Calendar onChange={this.handleMonthlyEffectiveDateChanged} value={this.state.monthEffectiveValue} minDate={new Date()} /></div> : null}</div>
                                          <img id="TransactionFeesDiscountCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="18" height="18" class="d-inline-block ml-1 " alt="" loading="lazy" onClick={this.toggleMonthlyEffectiveCalendar}
                                          />
                                       </div>
                                       <div class="activeTabTransactionExpiryDateDataDiv">
                                          <input class="TransactionFeesDiscountCalendarInputBox" readOnly placeholder="Select Date" value={this.state.monthlyExpiryDateCalendarRender ? monthlyExpiryDateValue : null}></input>
                                          <div class="TransactionFeesDiscountCalendar">  {this.state.showMonthlyExpiryCalendar ? <div ref={this.container}> <Calendar onChange={this.handleMonthlyExpiryDateChanged} value={this.state.monthExpiryValue} minDate={this.state.monthEffectiveValue} /></div> : null}</div>
                                          <img id="TransactionFeesDiscountCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="18" height="18" class="d-inline-block ml-1 " alt="" loading="lazy" onClick={this.toggleMonthlyExpiryCalendar}
                                          />
                                       </div>
                                       <div class="activeTabTransactionDiscountRateDiv">
                                          <input class="TransactionFeesDiscountRateInputBox" placeholder="Enter Value" value={this.state.monthlyTolAmt} onChange={e => {
                                             let value = e.target.value;
                                             value = value.replace(/[^0-9\.]/gi, "");
                                             this.setState({ monthlyTolAmt: value })
                                          }}></input>
                                       </div>
                                       <div class="TransactionFeesDiscountEditDeleteContainer">
                                          <div class="TransactionFeesDiscountEditDeleteDiv">
                                             <div id="TransactionFeesDiscountEditDeleteInnerDiv" class="text-right pl-3">
                                                <div id="TransactionFeesDiscountEditIconDiv" >
                                                   <img src={require('../../../assets/images/editenable.svg')} width="18" height="18" class="d-inline-block pr-1" alt="" loading="lazy" />
                                                </div>
                                                <div>
                                                   <img src={require('../../../assets/images/delete_enable.svg')} onClick={() => this.setState({ newRowMonth: false, emailAddress: '', fullName: '', monthlyEffectiveDateCalendarRender: false, monthlyExpiryDateCalendarRender: false, monthlyTolAmt: '' })} width="18" height="18" class="d-inline-block" alt="" loading="lazy" />
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>}
                                    {/* email search */}
                                    {this.state.showEmailSearch &&
                                       <div id="emailsearchlistTransactionFeesDiscount" ref={this.container}>
                                          {(filteredActiveData.map((email, emailindex) => {
                                             return (
                                                email.userType === "Premium" &&
                                                <dl class="pl-3 assignrolenamelistTransactionFeesDiscount" id="namelisthoverTransactionFeesDiscount" key={emailindex}
                                                   onClick={this.selectEmail}
                                                >
                                                   <dt>
                                                      <small id="assignrolenamelistTransactionFeesDiscountcolor"  >
                                                         {email.userEmail}
                                                      </small>
                                                   </dt>
                                                </dl>
                                             );
                                          }))
                                          }
                                       </div>
                                    }
                                    {/* Api Data */}
                                    {(this.state.transactionDiscountData.map((aname, index) => {
                                       return (aname.status === "Active" &&
                                          <div>
                                             {(!this.state.isEdit[index]) ?
                                                <div class="TransactionFeesDiscountActiveTabData">
                                                   <div class="activeTabTransactionEmailDataDiv">
                                                      <small class="activeTabDataTextTransactionFeesDiscount">{aname.userEmail}</small>
                                                   </div>
                                                   <div class="activeTabTransactionFullNameDataDiv">
                                                      <small class="activeTabDataTextTransactionFeesDiscount">{aname.fullName}</small>
                                                   </div>
                                                   <div class="activeTabTransactionEffectiveDateDataDiv">
                                                      <small class="activeTabDataTextTransactionFeesDiscount">{this.getDate(aname.effectiveDate)}</small>
                                                   </div>
                                                   <div class="activeTabTransactionExpiryDateDataDiv">
                                                      <small class="activeTabDataTextTransactionFeesDiscount">{this.getDate(aname.expiryDate)}</small>
                                                   </div>
                                                   <div class="activeTabTransactionDiscountRateDiv">
                                                      <small class="activeTabDataTextTransactionFeesDiscount">{aname.discountRate}</small>
                                                   </div>
                                                   <div class="TransactionFeesDiscountEditDeleteContainer"
                                                      style={{ display: !viewOnly ? "none" : null }}
                                                   >
                                                      <div class="TransactionFeesDiscountEditDeleteDiv">
                                                         <div id="TransactionFeesDiscountEditDeleteInnerDiv" class="text-right pl-3">
                                                            <div id="TransactionFeesDiscountEditIconDiv" >
                                                               <img src={(this.state.isEdit.includes(true)) ? require('../../../assets/images/editenable.svg') : require('../../../assets/images/edit.svg')} width="18" height="18" class="d-inline-block pr-1" alt="" loading="lazy"
                                                                  onClick={() => {
                                                                     if(!this.state.isEdit.includes(true)){
                                                                     let a = this.state.isEdit;
                                                                     a[index] = !this.state.isEdit[index];
                                                                     this.setState({ isEdit: a, editIndex: index });
                                                                     }
                                                                  }}
                                                               />
                                                            </div>
                                                            <div>
                                                               <img src={require('../../../assets/images/delete_enable.svg')} width="18" height="18" class="d-inline-block" alt="" loading="lazy" onClick={() => this.deleteMonthlySubscription(index)} />
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                                :
                                                <div class="newRowContainerEdit">
                                                   <div class="activeTabTransactionEmailDataDiv">
                                                      <input class="TransactionFeesDiscountAmtInputBoxEdit" readOnly value={this.state.transactionDiscountData[index].userEmail}></input>
                                                   </div>
                                                   <div class="activeTabTransactionFullNameDataDiv">
                                                      <input class="TransactionFeesDiscountfullNameInputBox" readOnly value={this.state.transactionDiscountData[index].fullName}></input>
                                                   </div>
                                                   <div class="activeTabTransactionEffectiveDateDataDiv">
                                                      <input class="TransactionFeesDiscountCalendarInputBox" placeholder="Select Date" readOnly
                                                         value={this.getDate(this.state.transactionDiscountData[index].effectiveDate)}></input>
                                                      <div class="TransactionFeesDiscountCalendar"> {this.state.showEditFromCalendar[index] ? <div ref={this.container}> <Calendar
                                                         onChange={(e) => {
                                                            let formatted_date = e.getDate() + "/" + [e.getMonth() + 1] + "/" + e.getFullYear();
                                                            if (e.getDate() <= 9) {
                                                               formatted_date = "0" + formatted_date;
                                                            }
                                                            this.state.transactionDiscountData[index].effectiveDate = formatted_date;
                                                            let showCalenderone = this.state.showEditFromCalendar;
                                                            showCalenderone[index] = false;
                                                            this.setState({ transactionDiscountData: this.state.transactionDiscountData, showEditFromCalendar: showCalenderone })
                                                         }}
                                                         minDate={new Date()} /></div> : null}</div>
                                                      <img id="TransactionFeesDiscountCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="18" height="18" class="d-inline-block ml-1 " alt="" loading="lazy"
                                                         onClick={() => {
                                                            let a = this.state.showEditFromCalendar;
                                                            a[index] = true
                                                            this.setState({ showEditFromCalendar: a, editIndex: index })
                                                         }}
                                                      />
                                                   </div>
                                                   <div class="activeTabTransactionExpiryDateDataDiv">
                                                      <input class="TransactionFeesDiscountCalendarInputBox" readOnly placeholder="Select Date" value={this.getDate(this.state.transactionDiscountData[index].expiryDate)}></input>
                                                      <div class="TransactionFeesDiscountCalendar">  {this.state.showEditToCalendar[index] ? <div ref={this.container}> <Calendar
                                                         onChange={(e) => {
                                                            let formatted_date = e.getDate() + "/" + [e.getMonth() + 1] + "/" + e.getFullYear();
                                                            if (e.getDate() <= 9) {
                                                               formatted_date = "0" + formatted_date;
                                                            }
                                                            this.state.transactionDiscountData[index].expiryDate = formatted_date;
                                                            let showCalenderone = this.state.showEditToCalendar;
                                                            showCalenderone[index] = false;
                                                            this.setState({ transactionDiscountData: this.state.transactionDiscountData, showEditToCalendar: showCalenderone })
                                                         }}
                                                         minDate={
                                                            new Date() >
                                                               new Date(aname.effectiveDate.split("/")[2], aname.effectiveDate.split("/")[1] - 1, aname.effectiveDate.split("/")[0]) ? new Date() : new Date(aname.effectiveDate.split("/")[2], aname.effectiveDate.split("/")[1] - 1, aname.effectiveDate.split("/")[0])
                                                         }
                                                      /></div> : null}</div>
                                                      <img id="TransactionFeesDiscountCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="18" height="18" class="d-inline-block ml-1 " alt="" loading="lazy"
                                                         onClick={() => {
                                                            let a = this.state.showEditToCalendar;
                                                            a[index] = true;
                                                            this.setState({ showEditToCalendar: a, editIndex: index })
                                                         }}
                                                      />
                                                   </div>
                                                   <div class="activeTabTransactionDiscountRateDiv">
                                                      <input class="TransactionFeesDiscountRateInputBox" placeholder="Enter Value" value={this.state.transactionDiscountData[index].discountRate}
                                                         onChange={(e) => {
                                                            let value = e.target.value;
                                                            value = value.replace(/[^0-9\.]/gi, "");
                                                            this.state.transactionDiscountData[index].discountRate = value;
                                                            this.setState({ transactionDiscountData: this.state.transactionDiscountData })
                                                         }}></input>
                                                   </div>
                                                   <div class="TransactionFeesDiscountEditDeleteContainer">
                                                      <div class="TransactionFeesDiscountEditDeleteDiv">
                                                         <div id="TransactionFeesDiscountEditDeleteInnerDiv" class="text-right pl-3">
                                                            <div id="TransactionFeesDiscountEditIconDiv" >
                                                               <img src={(this.state.isEdit[index]) ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')}
                                                                  width="18" height="18" class="d-inline-block pr-1" alt="" loading="lazy"
                                                                  onClick={() => {
                                                                     let a = this.state.isEdit;
                                                                     a[index] = !this.state.isEdit[index];
                                                                     this.setState({ isEdit: a });
                                                                  }} />
                                                            </div>
                                                            <div>
                                                               <img src={require('../../../assets/images/delete_disable.svg')} width="18" height="18" class="d-inline-block" alt="" loading="lazy" />
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                             }
                                          </div>
                                       );
                                    }))}
                                 </div>
                                 <div class="TransactionFeesDiscountCardFooter" style={{ display: !viewOnly ? "none" : null }}>
                                    <div class="TransactionFeesDiscountCardFooterDiv">
                                       <div class="TransactionFeesDiscountNoteDiv">
                                          <Link onClick={this.addNewRoleMonth} style={{ cursor: this.state.newRowMonth ? "default" : "pointer" }}>
                                             <img src={this.state.newRowMonth ? require('../../../assets/images/plus_disable.svg') : require('../../../assets/images/add.svg')} width="18" height="18" class="d-inline-block" id="TransactionFeesDiscountAddNewRowIcon" alt="" loading="lazy" />
                                             <small class="" id="TransactionFeesDiscountaddNewRowLink" style={{ color: this.state.newRowMonth ? "#B6B6B6" : "#428BCA" }}>Add New Row</small>
                                          </Link>
                                       </div>
                                       <div>
                                          <div class="TransactionFeesDiscountButtonDiv">
                                             <button class="TransactionFeesDiscountConfirmButton" disabled={!this.validateFormFields()} onClick={this.addDiscount}><small class={!this.validateFormFields() ? "TransactionFeesDiscountButtonTextDisabled" : "TransactionFeesDiscountButtonText"}>Confirm</small></button>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>}
                              {this.state.monthlyExpiredDiv && <div>
                                 <div class="TransactionFeesDiscountDataContainerExpired">
                                    <div class="TransactionFeesDiscountDataHeader">
                                       <div class="activeEmailAddressExpiredDiv"><div class="TransactionFeesDiscountEffectiveDate">
                                          <small class="dataHeaderTextTransactionFees">Email Address</small>
                                          <small class="dataHeaderTextTransactionFees">(Premium User)</small>
                                       </div></div>
                                       <div class="activeFullNameExpiredDiv"><div class="TransactionFeesDiscountExpiredDate">
                                          <small class="dataHeaderTextTransactionFees">Full Name</small>
                                       </div></div>
                                       <div class="activeDiscountEffectiveExpiredDiv"><div class="TransactionFeesDiscountActiveAmt">
                                          <small class="dataHeaderTextTransactionFees">Discount</small>
                                          <small class="dataHeaderTextTransactionFees">Effective Date</small>
                                       </div></div>
                                       <div class="activeDiscountExpiryExpiredDiv"><div class="TransactionFeesDiscountExpiryDate">
                                          <small class="dataHeaderTextTransactionFees">Discount</small>
                                          <small class="dataHeaderTextTransactionFees">Expiry Date</small>
                                       </div></div>
                                       <div class="activeDiscountRateExpiredDiv"><div class="TransactionFeesDiscountRate">
                                          <small class="dataHeaderTextTransactionFees">Discount</small>
                                          <small class="dataHeaderTextTransactionFees">Rate(%)</small>
                                       </div></div>
                                    </div>
                                    <div className="expirySubscriptionsTransactionFeesDiscount">
                                       {(this.state.transactionDiscountData.map((ename, index) => {
                                          return (ename.status === "Expired" &&
                                             <div class="TransactionFeesDiscountexpiredDataRow" id="TransactionFeesDiscountTableDataContainerExpired">
                                                <div class="expiredTabTransactionEmailDataDiv">
                                                   <small class="activeTabDataTextTransactionFeesDiscount">{ename.userEmail}</small>
                                                </div>
                                                <div class="expiredTabTransactionFullNameDataDiv">
                                                   <small class="activeTabDataTextTransactionFeesDiscount">{ename.fullName}</small>
                                                </div>
                                                <div class="expiredTabTransactionEffectiveDateDataDiv">
                                                   <small class="activeTabDataTextTransactionFeesDiscount">{this.getDate(ename.effectiveDate)}</small>
                                                </div>
                                                <div class="expiredTabTransactionExpiryDateDataDiv">
                                                   <small class="activeTabDataTextTransactionFeesDiscount">{this.getDate(ename.expiryDate)}</small>
                                                </div>
                                                <div class="expiredTabTransactionDiscountRateDiv">
                                                   <small class="activeTabDataTextTransactionFeesDiscount">{ename.discountRate}</small>
                                                </div>
                                             </div>
                                          );
                                       }))}
                                    </div>
                                 </div>
                              </div>}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <DeleteModal hasOpen={this.state.hasOpenDelete} onClick={this.onCloseDeleteModal} onYesClick={this.confirmDelete} >
               <p className="deletemodalText">Do you really want to delete this discount?</p>
            </DeleteModal>
            <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
               <p className="confirmedText">Confirmed</p>
            </SuccessModal>
            <AlertModal hasOpen={this.state.hasOpenAlert} onClick={this.onCloseAlert}>
               <div className="wholecontainerTransactionFeesDiscount">
                  <p className="alertSectionUpperTextTransactionFeesDiscount">You have selected invalid date range as discount is already available for this user for some of the dates for this date range.</p>
                  <h6 className="alertSectionLowerTextTransactionFeesDiscount">Please select different date range.</h6>
               </div>
            </AlertModal>
         </div>
      );
   }
}
function mapStateToProps(state) {
   return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(TransactionFeesDiscount);